<main class="main">
  <div class="container-fluid">
    <br />
    <alert></alert>
    <br />
    <div class="mb-3">
      <span class="icon-left text-secondary"></span>
      <a [routerLink]="[destinoRouter]">   {{'WorkflowCreate.Back' | translate}}</a>
    </div>
    <div style="display: none">{{'SubmissionExSubscriberSuccessManifest.ConfirmSubmissionText' | translate}}</div>
  </div>


</main>


